const initB2BFormSuccessState = () => {
  const url = new URL(window.location.href);
  if (!url.searchParams.get('contact_posted') || !url.hash) {
    return;
  }

  const formId = url.hash.substring(1);

  const showSuccessMessage = () => {
    const successEl =
      document.getElementById('b2b-form-success--' + formId) ||
      document.getElementById('b2b-form-success-' + formId);

    if (successEl) {
      successEl.style.display = '';
      const container = successEl.closest('form')?.querySelector('.b2b-form__form-fields-container');
      if (container) {
        container.style.display = 'none';
      }
    }
  };

  showSuccessMessage();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initB2BFormSuccessState, { once: true });
} else {
  initB2BFormSuccessState();
}
